import axios from 'axios';

const setupAxiosInterceptors = (setAuth, navigate) => {

    const onRequestSuccess = (config) => {
        return config;
    };

    const onResponseError = (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('token');
            setAuth({ token: null, userData: {} });
            navigate('/');
        }
        return Promise.reject(error);
    };

    axios.interceptors.request.use(onRequestSuccess);
    axios.interceptors.response.use(response => response, onResponseError);
};

export default setupAxiosInterceptors;
